module.exports = "<p l10nTranslate>\r\n  auth-key\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/src/app/auth/auth.component.html
// module id = ../../../../../src/app/auth/auth.component.html
// module chunks = 1